import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { X, GoogleLogo, Lock } from "@phosphor-icons/react";

export default function AuthModal() {
  const { authModalOpen, setAuthModalOpen } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  if (!authModalOpen) return null;

  const close = () => setAuthModalOpen(false);

  const goLogin = () => {
    close();
    navigate(`/login?next=${encodeURIComponent(location.pathname + location.search)}`);
  };
  const goSignup = () => {
    close();
    navigate(`/signup?next=${encodeURIComponent(location.pathname + location.search)}`);
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div
      className="fixed inset-0 z-[60] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={(e) => e.target === e.currentTarget && close()}
      data-testid="auth-modal-overlay"
    >
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-2xl shadow-2xl relative" data-testid="auth-modal">
        <button
          onClick={close}
          className="absolute top-4 right-4 p-2 hover:bg-slate-100 rounded-lg transition-colors text-slate-500"
          data-testid="auth-modal-close"
          aria-label="Close"
        >
          <X size={18} />
        </button>

        <div className="p-8">
          <div className="w-10 h-10 bg-blue-600 rounded-xl flex items-center justify-center mb-5">
            <Lock size={20} weight="fill" color="#fff" />
          </div>
          <span className="text-xs font-semibold uppercase tracking-wider text-slate-400">
            Members only
          </span>
          <h2 className="font-bold text-2xl text-slate-900 mt-2 leading-tight">
            Sign in to read the full story
          </h2>
          <p className="text-sm text-slate-500 mt-3 leading-relaxed">
            Create a free account to unlock article detail pages, generate AI content kits, and save your work.
          </p>

          <div className="mt-6 space-y-3">
            <button
              onClick={goLogin}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 text-sm rounded-lg transition-colors"
              data-testid="auth-modal-login-button"
            >
              Sign in
            </button>
            <button
              onClick={goSignup}
              className="w-full border border-slate-200 hover:bg-slate-50 text-slate-800 font-semibold py-3 text-sm rounded-lg transition-colors"
              data-testid="auth-modal-signup-button"
            >
              Create free account
            </button>
            <div className="flex items-center gap-3 my-2">
              <div className="flex-1 h-px bg-slate-200" />
              <span className="text-xs font-medium uppercase tracking-wider text-slate-400">OR</span>
              <div className="flex-1 h-px bg-slate-200" />
            </div>
            <button
              onClick={googleLogin}
              className="w-full bg-white text-slate-800 border border-slate-200 hover:bg-slate-50 font-semibold py-3 text-sm rounded-lg transition-colors inline-flex items-center justify-center gap-2"
              data-testid="auth-modal-google-button"
            >
              <GoogleLogo size={16} weight="bold" /> Continue with Google
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
